// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__17kAc","approved":"Status_approved__3e8z9","rejected":"Status_rejected__2QeOj","expired":"Status_expired__20eb5","label":"Status_label__lZwTM"};